(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swedbank-express/pages/change-bank/change-bank.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swedbank-express/pages/change-bank/change-bank.js');
'use strict';

const Button = svs.ui.ReactButton;
const {
  Form,
  ControlGroup,
  Select,
  Option
} = svs.ui.reactForm;
const logger = svs.accountservicesReact.deposit.swedbankExpress.logger;
const ChangeBank = _ref => {
  let {
    onClickChangeBank,
    onClickReturn,
    bankList,
    isConsentSelectBank
  } = _ref;
  const [selectedBankSubsidiaryId, setSelectedBankSubsidiaryId] = React.useState('-1');
  const [isBankSelected, setIsBankSelected] = React.useState(false);
  React.useEffect(() => {
    if (bankList && bankList.length > 0) {
      const recentBank = bankList.find(b => b.recent === 1);
      if (recentBank && recentBank.bankSubsidiaryId) {
        logger.debug('*** ChangeBank - Found recent Bank, changing dropdow to: ', recentBank);
        setSelectedBankSubsidiaryId(recentBank.bankSubsidiaryId);
        setIsBankSelected(true);
      }
    }
  }, [bankList]);

  const handleOnChangeBank = e => {
    setSelectedBankSubsidiaryId(e.target.value);
    setIsBankSelected(true);
  };
  const handleOnClickChangeBank = () => {
    onClickChangeBank({
      bankSubsidiaryId: selectedBankSubsidiaryId,
      isConsentSelectBank
    });
  };
  const handleOnClickReturn = () => {
    onClickReturn();
  };
  let counter = 0;
  return React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement(Form, {
    method: "post"
  }, React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(Select, {
    id: "bankslist",
    label: "Bank",
    onChange: e => handleOnChangeBank(e),
    v2: true,
    value: selectedBankSubsidiaryId
  }, React.createElement(Option, {
    disabled: true,
    value: "-1"
  }, "V\xE4lj bank"), bankList && bankList.length > 0 && bankList.map(bank => React.createElement(Option, {
    key: bank.bankSubsidiaryId + counter++,
    value: bank.bankSubsidiaryId
  }, bank.bankName)))), React.createElement(Button, {
    block: true,
    className: "margin-top-2",
    disabled: !isBankSelected,
    focus: true,
    onClick: handleOnClickChangeBank
  }, "H\xE4mta bankkonton"), React.createElement(Button, {
    block: true,
    className: "margin-top-1",
    onClick: handleOnClickReturn,
    transparent: true
  }, "Tillbaka")));
};
svs.accountservicesReact.deposit.swedbankExpress.pages.changeBank.ChangeBank = ChangeBank;

 })(window);